import pngfooter2 from "../../assets/images/pngfooter2.svg";
import date from "../../assets/images/date.png";
import copyright from "../../assets/images/copyright.png";
import { useTranslation } from "react-i18next";

function Footer2() {
  const { t, i18n } = useTranslation();
  return (
    <div className="row px-lg-5 px-2 pb-md-0 mx-0 pbs">
      <div className="col-12">
        <div className="row  footer-txt pt-md-3 pt-3">
          <div className="col-lg-8  col-12 ">{t("footer1")}</div>
          <div className="col-12">{t("footer2")}</div>
        </div>
        <div className="row pt-4 pb-1">
          <div className="col-12 ">
            <img src={pngfooter2} alt="footer-image" className="width-visa" />
          </div>
        </div>
        <div className="d-flex justify-content-end pb-md-0 pb-2 date align-items-center">
          <img
            src={copyright}
            alt="Libas' trademark and copyright"
            className={`copyright ${i18n.language === "en" ? "me-1" : "ms-1"}`}
          />
          <span className={i18n.language === "ar" ? "ms-1" : "me-1"}>
            {new Date().getFullYear()}
          </span>
          <span className={i18n.language === "ar" ? "ms-1" : "me-1"}>
            {i18n.language === "en"
              ? "Libas International FZCO"
              : "لباس انترناشونال - ش م ح"}
          </span>
        </div>

        <div className="pb-3"></div>
      </div>
      {/*  me-1 ms-1 ${i18n.language=='en'?"me-1":"ms-1" */}
    </div>
  );
}

export default Footer2;
